import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import * as Icons from "lucide-react";
import { Activity } from "lucide-react";
import { HeroFade, StaggerGrid, StaggerItem } from "@/lib/motion";
import { useSEO } from "@/hooks/useSEO";

const IconOf = ({ name, className }) => {
  const Ico = Icons[name] || Activity;
  return <Ico className={className} strokeWidth={1.75} />;
};

export default function Services() {
  const [services, setServices] = useState([]);
  useEffect(() => {
    api.get("/services").then(({ data }) => setServices(data));
  }, []);

  useSEO({
    title: "Healthcare Services - Cardiology, Radiology, Emergency",
    description: "Explore clinical services at Afzal Medical Complex, including cardiology, emergency care, digital pathology lab, advanced CT/MRI diagnostics, and inpatient suites."
  });

  return (
    <div data-testid="services-page">
      <section className="section bg-red-50/40">
        <div className="container-medi max-w-3xl">
          <HeroFade><div className="overline mb-3">Our Services</div></HeroFade>
          <HeroFade delay={0.1}><h1 className="text-4xl sm:text-5xl font-heading font-semibold tracking-tight text-slate-900">Complete care, from prevention to recovery</h1></HeroFade>
          <HeroFade delay={0.2}><p className="mt-5 text-slate-600 text-lg">Every service is delivered by experienced clinicians and supported by modern technology — because healthcare should be trusted, safe and dignified.</p></HeroFade>
        </div>
      </section>

      <section className="section">
        <StaggerGrid className="container-medi grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((s) => (
            <StaggerItem key={s.id} className="card-medi p-6" data-testid={`service-item-${s.id}`}>
              <div className="w-12 h-12 rounded-2xl bg-red-50 text-red-700 grid place-items-center mb-4">
                <IconOf name={s.icon} className="w-6 h-6" />
              </div>
              <h3 className="font-heading font-semibold text-lg text-slate-900">{s.name}</h3>
              <p className="mt-2 text-sm text-slate-600 leading-relaxed">{s.description}</p>
            </StaggerItem>
          ))}
        </StaggerGrid>
      </section>
    </div>
  );
}
